<template>
  <div class="mobile-menu-wrap hidden-sm-and-up" :class="{active: $store.state.mobileMenuActive}">
    <div class="overlay" @click="$store.commit('setState', {mobileMenuActive: false})">
    </div>
    <div class="menu">
      <div class="main-header">
        <router-link to="/" class="logo">
          <img src="/static/logo_mobile.svg" alt="">
        </router-link>
        <!--<router-link to="/" class="logo" style="padding-left: 0">-->
          <!--<img src="/static/embibe.svg" style="height: auto;width: 220px;" v-if="$store.state.env === 'development'">-->
          <!--<img src="/images/embibe.svg" style="height: auto;width: 220px;" v-else>-->
        <!--</router-link>-->
        <div class="mobile-menu-btn " @click="$store.commit('setState', {mobileMenuActive: false})">
          <div class="cross">

          </div>
        </div>
      </div>
      <div class="links">
      <!--<router-link @click.native="$store.commit('setState', {mobileMenuActive: false})" to="/my-classes">My classes</router-link>-->
      <!--<router-link @click.native="$store.commit('setState', {mobileMenuActive: false})" to="/my-library">-->
        <!--My Library-->
      <!--</router-link>-->
      <!--<router-link @click.native="$store.commit('setState', {mobileMenuActive: false})" to="/library">-->
        <!--COOBO Library-->
      <!--</router-link>-->

        <!--<div v-if='["class", "assessment", "result", "student", "tours", "analytics"].indexOf($route.name) !== -1'>-->
          <!--<router-link @click.native="$store.commit('setState', {mobileMenuActive: false})" :to="'/class/'+$route.params.id">Students</router-link>-->
          <!--<router-link @click.native="$store.commit('setState', {mobileMenuActive: false})" :to="'/assessment/'+$route.params.id">Assessment</router-link>-->
          <!--<router-link @click.native="$store.commit('setState', {mobileMenuActive: false})" :to="'/analytics/'+$route.params.id">Analytics</router-link>-->
          <!--<router-link @click.native="$store.commit('setState', {mobileMenuActive: false})" :to="'/tours/'+$route.params.id">Tours</router-link>-->
        <!--</div>-->

        <router-link  to="/" @click.native="$store.commit('setState', {mobileMenuActive: false})">Showcase</router-link>
        <router-link  to="/my-library" :class="{'is-active' : ['my-library'].indexOf($route.name) !== -1 }" @click.native="$store.commit('setState', {mobileMenuActive: false})">
          My Library
        </router-link>
        <a v-if="$store.state.env === 'development'" :href="$store.state.API_URL + 'edit/new?jwt=' + getJwt()" :class="{'is-active' : ['my-library'].indexOf($route.name) !== -1 }" >
          Create New Tour
        </a>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'App',
    data() {
      return {
        activeIndex: '1',
        activeIndex2: '1',
//        loggedIn: false,
        registerModal: false
      }
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      handleSelect(key, keyPath) {
//        console.log(key, keyPath);
      },
      register(role) {
        this.$router.push(role);
        this.registerModal = false
      },
      getJwt() {
        return localStorage.getItem("jwt")
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/mobile-menu.vue